/**
 * What's New configuration.
 *
 * WHATS_NEW_URL: URL to the remote JSON file hosted on DigitalOcean Spaces.
 * Update the URL after uploading whats-new.json to your Spaces bucket.
 *
 * JSON structure — array of objects sorted by id (newest first):
 * [
 *   {
 *     "id": 1,              // unique, incrementing
 *     "date": "2026-04-21", // YYYY-MM-DD
 *     "type": "feature",    // "feature" | "improvement" | "fix"
 *     "title": "...",
 *     "description": "...",
 *     "image": null,        // optional — full URL to a preview image
 *     "link": null           // optional — internal route e.g. "/projects"
 *   }
 * ]
 */
export const WHATS_NEW_URL = "https://api.npoint.io/7eb77e33252a1aced9d9";

export const typeConfig = {
  feature: { label: "ميزة جديدة", color: "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300" },
  improvement: { label: "تحسين", color: "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300" },
  fix: { label: "إصلاح", color: "bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-300" },
};
